import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class Availability extends BaseAPIModel {
    // Allow us to call getAll directly
    static list(item) {
        return item;
    }

    static listUrl({ organizationId, eventId, inventoryId, zoneId = null }) {
        if (!organizationId || !eventId || !inventoryId) {
            throw new ArgumentError(`[Model][Availability][getAll] organizationId, eventId and inventoryId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/inventories/${inventoryId}/zones${zoneId ? '/' + zoneId : ''}`;
    }
}
